import * as styles from './styles.css';
import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

export interface IVacancyLayoutProps {
  header: React.ReactElement;
  vacancy: React.ReactElement;
  footer: React.ReactElement;
}
export const VacancyLayout: React.FC<IVacancyLayoutProps> = ({ header, footer, vacancy }) => {
  const deviceType = useDeviceType();

  return (
    <section className={styles.root}>
      <header className={styles.header}>{header}</header>
      <main className={cn(styles.main, styles[deviceType])}>
        <div className={styles.vacancy}>{vacancy}</div>
      </main>
      <footer>{footer}</footer>
    </section>
  );
};
